import axios from "axios";

import Token from "../../utilities/jwt/Token.js";

export default class permissoesService extends Token {
  
  findAll() {
    return axios({
      method: "get",
      url: this.api_url + "permissoes",
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + this.token(),
      },
    }).then((res) => res.data);
  }

  create(permissoes) {
    return axios({
      method: "post",
      url: this.api_url + "permissoes",
      withCredentials: true,
      data: permissoes,
      headers: {
        Authorization: "Bearer " + this.token(),
      },
    });
  }
  
  update(permissoes) {
    return axios({
      method: 'put',
      url: this.api_url + 'permissoes/' + permissoes.id,
      withCredentials: true,
      data: permissoes,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });

  }

  delete(id) {
    return axios({
      method: 'delete',
      url: this.api_url + 'permissoes/' + id,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });

  }
}
